var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "stroke-color-main",
    x: 23.689,
    y: 23.689,
    width: 64.698,
    height: 64.698
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "stroke-color-main",
    x: 111.613,
    y: 23.689,
    width: 64.698,
    height: 64.698
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "stroke-color-main",
    x: 111.613,
    y: 111.613,
    width: 64.698,
    height: 64.698
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "stroke-color-main",
    x: 23.689,
    y: 111.613,
    width: 64.698,
    height: 64.698
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.0828e87d3eed68ac0af6760fbb45768c.svg";
export { ForwardRef as ReactComponent };